import axios from 'axios'
import Qs from 'qs'

const axiosRequest = axios.create({
  // `url` 是用于请求的服务器 URL，在请求时会被提供的url覆盖
  url: '/user',

  // `method` 是创建请求时使用的方法
  method: 'get', // 默认是 get

  // `baseURL` 将自动加在 `url` 前面，除非 `url` 是一个绝对 URL。
  // 它可以通过设置一个 `baseURL` 便于为 axios 实例的方法传递相对 URL
  baseURL: window.LOCAL_CONFIG.BASE_URL,

  // `transformRequest` 允许在向服务器发送前，修改请求数据
  // 只能用在 'PUT', 'POST' 和 'PATCH' 这几个请求方法
  // 后面数组中的函数必须返回一个字符串，或 ArrayBuffer，或 Stream
  transformRequest: [function (data) {
    data.auth_token = (sessionStorage.getItem('auth_token') || null) // 为所有请求添加auth_token参数
    data = Qs.stringify(data, {arrayFormat: 'repeat'})
    // 对 data 进行任意转换处理
    return data
  }],

  // `transformResponse` 在传递给 then/catch 前，允许修改响应数据
  transformResponse: [function (data) {
    // 对 data 进行任意转换处理
    return data
  }],

  // `headers` 是即将被发送的自定义请求头
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'Content-Type': 'application/x-www-form-urlencoded',
    'Access-Control-Allow-Origin': '*'
  },

  // `params` 是即将与请求一起发送的 URL 参数
  // 必须是一个无格式对象(plain object)或 URLSearchParams 对象
  params: {

  },

  // `paramsSerializer` 是一个负责 `params` 序列化的函数
  // (e.g. https://www.npmjs.com/package/qs, http://api.jquery.com/jquery.param/)
  paramsSerializer: function (params) {
    return Qs.stringify(params, {arrayFormat: 'repeat'})
  },

  // `data` 是作为请求主体被发送的数据
  // 只适用于这些请求方法 'PUT', 'POST', 和 'PATCH'
  // 在没有设置 `transformRequest` 时，必须是以下类型之一：
  // - string, plain object, ArrayBuffer, ArrayBufferView, URLSearchParams
  // - 浏览器专属：FormData, File, Blob
  // - Node 专属： Stream
  data: {

  },

  // `timeout` 指定请求超时的毫秒数(0 表示无超时时间) 10min
  // 如果请求话费了超过 `timeout` 的时间，请求将被中断
  timeout: 600000,

  withCredentials: true, // 默认的

  // `responseType` 表示服务器响应的数据类型，可以是 'arraybuffer', 'blob', 'document', 'json', 'text', 'stream'
  responseType: 'json', // 默认的

  // `maxContentLength` 定义允许的响应内容的最大尺寸
  maxContentLength: 2000,

  // `validateStatus` 定义对于给定的HTTP 响应状态码是 resolve 或 reject  promise 。如果 `validateStatus` 返回 `true` (或者设置为 `null` 或 `undefined`)，promise 将被 resolve; 否则，promise 将被 rejecte
  validateStatus: function (status) {
    return status >= 200 && status < 300 // 默认的
  },

  // `maxRedirects` 定义在 node.js 中 follow 的最大重定向数目
  // 如果设置为0，将不会 follow 任何重定向
  maxRedirects: 5 // 默认的
})

// 请求拦截 头部增加csrftoken
axiosRequest.interceptors.request.use((config) => {
  config.headers['csrftoken'] = localStorage.getItem('csrftoken')
  return config
})
// 响应拦截，处理ie接收到的data为字符串
axiosRequest.interceptors.response.use((response) => {
  if (typeof response.data === 'string') {
    response.data = JSON.parse(response.data)
  }
  return response
})

export default axiosRequest



// WEBPACK FOOTER //
// ./src/api/axios.js